import React from "react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import MenuSection from "@/components/MenuSection";
import Manifesto from "@/components/Manifesto";
import Footer from "@/components/Footer";
import MenuJsonLd from "@/components/MenuJsonLd";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import BatchPopup from "@/components/BatchPopup";
import OrderAnywhereCard from "@/components/OrderAnywhereCard";
import GiftCardPromo from "@/components/GiftCardPromo";
import useSEO from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "BIGA | Roman-Style Pizza in Vadodara",
    description: "Order authentic 7.5 × 11.5\" Roman-style pizza in Vadodara, baked fresh on 72-hour fermented biga dough. Located at Gotri Sevasi Road. Direct takeaway & delivery.",
    path: "/",
  });
  return (
    <main>
      <MenuJsonLd />
      <AnnouncementBanner />
      <Hero />
      <Marquee />
      <MenuSection />
      <OrderAnywhereCard />
      <GiftCardPromo />
      <Manifesto />
      <Footer />
      <BatchPopup />
    </main>
  );
}
